var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24.8621,
    height: 24,
    rx: 4.5,
    fill: "white",
    stroke: "#EFF0F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6796 7.72278H9.26729C8.90528 7.72278 8.5581 7.86659 8.30213 8.12256C8.04615 8.37854 7.90234 8.72572 7.90234 9.08772V16.5949C7.90234 16.9569 8.04615 17.3041 8.30213 17.5601C8.5581 17.816 8.90528 17.9598 9.26729 17.9598H16.7745C17.1365 17.9598 17.4837 17.816 17.7396 17.5601C17.9956 17.3041 18.1394 16.9569 18.1394 16.5949V13.1825M17.1744 6.75777C17.3003 6.6274 17.4509 6.52341 17.6175 6.45188C17.784 6.38034 17.9631 6.34269 18.1443 6.34112C18.3256 6.33954 18.5053 6.37408 18.673 6.44271C18.8408 6.51134 18.9932 6.61269 19.1213 6.74085C19.2495 6.869 19.3509 7.0214 19.4195 7.18915C19.4881 7.3569 19.5227 7.53663 19.5211 7.71787C19.5195 7.8991 19.4818 8.07821 19.4103 8.24474C19.3388 8.41127 19.2348 8.56188 19.1044 8.68779L13.2447 14.5475H11.3147V12.6175L17.1744 6.75777Z",
    stroke: "#3F3F46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.597e3ab3cda229a1271730e30e6acfaf.svg";
export { ForwardRef as ReactComponent };